<template>
  <div class="row">
    <div id="msform">
      <div
        v-if="index > 1"
        class="back-icon"
        @click="onBack()">
        <i class="fa fa-arrow-left"/>
      </div>
      <ul id="progressbar">
        <li :class="{'active': index >= 1}">Số điện thoại</li>
        <li :class="{'active': index >= 2}">Xác nhận</li>
      </ul>
    </div>
    <div
      v-if="index === 1"
      class="content">
      <h5>Thông tin khách hàng</h5>
      <form @submit.prevent="onSavePhone">
        <div class="form-group">
          <div class="col-12">
            <input
              v-model="phone"
              type="text"
              class="form-control"
              placeholder="Số điện thoại">
            <span style="color: red">Khóa học sẽ đăng ký cho số điện thoại này</span>
          </div>
        </div>
        <button
          type="submit"
          class="btn btn-success col-12">Mua
        </button>
      </form>
    </div>
    <div
      v-if="index === 2"
      class="content-confirm">
      <div class="confirm">
        <div class="title">Số điện thoại</div>
        <div class="detail">{{ phone }}</div>
      </div>
      <div class="confirm">


        <div class="title">Phương thức thanh toán</div>
        <div class="detail">Thanh toán qua Viettel Pay</div>
      </div>
      <div class="confirm">
        <div class="title">Thông tin khóa học</div>
        <div>
          <table
            v-if="course"
            class="table">
            <tbody>
              <tr>
                <td>
                  <i class="fa fa-leanpub"/> Tên khóa học
                </td>
                <td>{{ course.name }}</td>
              </tr>
              <tr>
                <td>
                  <i class="fa fa-graduation-cap"/> Giảng viên
                </td>
                <td>{{ course.author }}</td>
              </tr>
              <tr>
                <td>
                  <i class="fa fa-clock-o"/> Thời lượng
                </td>
                <td>{{ course.duration }}</td>
              </tr>
              <tr>
                <td>
                  <i class="fa fa-thumbs-o-up"/> Likes
                </td>
                <td>{{ course.nr_view }}</td>
              </tr>
              <tr>
                <td>
                  <i class="fa fa-star-o"/> Rating
                </td>
                <td>8225</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="confirm">
        <div class="amount-detail">
          <div class="title">Thành tiền:</div>
          <span class="amount">{{ course && course.cost }} đ</span>
        </div>
        <div class="detail-vat text-right">Đã bao gồm VAT</div>
        <button
          :disabled="isSubmitting"
          type="button"
          class="btn btn-success col-12"
          @click="order()">Tiến hành thanh toán
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import CardItem from "../cart/CardItem";
  import rf from "../../communicate/RequestFactory";
  import {errorToaster, infoToaster} from '../../services/ErrorHandler'
  import {isLoggedIn} from '../../services/authService'
  import OrderType from '../../communicate/OrderType'

  export default {
    name: "CoursePayment",
    components: {
      CardItem
    },

    data () {
      return {
        index: 1,
        phone: "",
        payment_method: 9,
        course: {},
        amount: 0,
        loader: null,
        isSubmitting: false
      };
    },
    mounted () {
      this.loadCourse();
      const userInfoStorage = localStorage.getItem("current_user");
      if (userInfoStorage) {
        const userInfo = JSON.parse(userInfoStorage);
        this.phone = userInfo.phone;
      }
    },
    methods: {
      onSavePhone () {
        this.index = 2;
      },
      loadCourse () {
        const courseStorage = sessionStorage.getItem("course");
        this.course = courseStorage ? JSON.parse(courseStorage) : {};
      },
      onBack () {
        if (this.index > 0) {
          this.index--;
        }
      },
      onNext () {
        this.index++;
      },

      order () {
        this.loader = this.$loading.show();
        this.isSubmitting = true;
        const data = {
          payment_method: this.payment_method,
          receiver_phone: this.phone,
          receiver_name: '',
          receiver_address: '',
          course_id: this.course.id
        };

        this.$Progress.start();
        rf.getRequest("OrderRequest")
          .orderCourse(data)
          .then(res => {
            if (res.status === 200) {
              const req = {
                order_id: res.data.id,
                order_code: res.data.order_code,
                customer_number: this.phone,
                description: `Thanh toan don hang ${res.data.order_code}`,
                payment_method: res.data.payment_method,
                amount: parseInt(res.data.price),
                payment_type: OrderType.ORDER_KH
              };

              sessionStorage.removeItem("course");
              this.$Progress.finish();
              this.requestVietel(req);
            } else if (res.status === 515) {
              infoToaster("Cố vấn Phong Thủy", res.message);
              this.loader.hide();
              this.$Progress.fail();
              this.isSubmitting = false;
              if (!isLoggedIn()) {
                this.$router.push("/login");
              }
            } else {
              this.loader.hide();
              errorToaster("Cố vấn Phong Thủy", "Xảy ra lỗi kết nối");
              this.$Progress.fail();
              this.isSubmitting = false;
            }
          })
          .catch(err => {
            this.loader.hide();
            this.isSubmitting = false;
            errorToaster("Cố vấn Phong Thủy", "Xảy ra lỗi kết nối");
            this.$Progress.fail();
          });
      },

      requestVietel (req) {
        rf.getRequest("OrderRequest")
          .viettelPay(req)
          .then(res => {
            this.loader.hide();
            this.isSubmitting = false;
            if (res.status === 200) {
              window.location.href = res.data;
            }
          })
          .catch(err => {
            this.loader.hide();
            this.isSubmitting = false;
            errorToaster("Cố vấn Phong Thủy", "Xảy ra lỗi kết nối");
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .back-icon {
    position: absolute;
    top: 24px;
    font-size: 18px;
    color: gray;
    cursor: pointer;
    z-index: 10;
  }

  .content {
    .radio {
      display: block;
      position: relative;
      padding-left: 30px;
      margin-bottom: 12px;
      cursor: pointer;
      font-size: 20px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    .radio input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    .checkround {
      position: absolute;
      top: 6px;
      left: 0;
      height: 20px;
      width: 20px;
      background-color: #fff;
      border-color: #34c300;
      border-style: solid;
      border-width: 2px;
      border-radius: 50%;
    }

    .radio input:checked ~ .checkround {
      background-color: #fff;
    }

    .checkround:after {
      content: "";
      position: absolute;
      display: none;
    }

    .radio input:checked ~ .checkround:after {
      display: block;
    }

    .radio .checkround:after {
      left: 2px;
      top: 2px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #34c300;
    }
  }

  .content-confirm {
    width: 100%;

    .confirm {
      padding: 16px;
      background: #fff none repeat scroll 0% 0%;
      margin: 8px 0px;
      width: 100%;

      .title {
        font-weight: bold;
        font-size: 18px;
        padding-bottom: 5px;
      }

      .detail {
        color: gray;
        margin-bottom: 4px;
        font-size: 14px;
      }

      .detail-vat {
        color: gray;
        margin-bottom: 4px;
        font-size: 14px;
        display: inline-block;
        width: 100%;
      }

      .amount-detail {
        width: 100%;

        .title {
          float: left;
          font-weight: bold;
          font-size: 18px;
          padding-bottom: 5px;
        }

        .amount {
          color: red;
          font-weight: bold;
          float: right;
          font-size: 18px;
          padding-bottom: 5px;
        }
      }
    }
  }

  #msform {
    width: 100%;
    margin: 10px auto 0 auto;
    text-align: center;
    position: relative;
  }

  /*buttons*/
  #msform .action-button {
    width: 100px;
    background: #27ae60;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 1px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
  }

  #msform .action-button:hover,
  #msform .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #27ae60;
  }

  /*progressbar*/
  #progressbar {
    margin: 20px 0 10px 0;
    overflow: hidden;
    /*CSS counters to number the steps*/
    counter-reset: step;
  }

  #progressbar li {
    list-style-type: none;
    text-transform: uppercase;
    font-size: 10px;
    width: 50%;
    float: left;
    position: relative;
  }

  #progressbar li:before {
    content: counter(step);
    counter-increment: step;
    width: 30px;
    height: 30px;
    line-height: 30px;
    display: block;
    font-size: 10px;
    color: #efefef;
    /*border-top: 2px solid #fff;*/
    background: #efefef;
    border-radius: 50%;
    margin: 0 auto 5px auto;
  }

  /*progressbar connectors*/
  #progressbar li:after {
    content: "";
    width: 100%;
    height: 2px;
    background: #dddddd;
    position: absolute;
    left: -50%;
    top: 15px;
    z-index: -1;
  }

  #progressbar li:first-child:after {
    content: none;
  }

  #progressbar li.active:before,
  #progressbar li.active:after {
    background: #418aeb;
    color: #418aeb;
  }

  input[type="radio"]:checked {
    color: #418aeb;
  }
</style>



// WEBPACK FOOTER //
// src/components/course/CoursePayment.vue